<template>
  <div class="app-container" id="ads">
    <div class="banner" text="center">
      <div class="banner-desc">
        <h1>一个在浏览器中免费制作GIF的网站</h1>
        <p>EASY GIF</p>
      </div>
    </div>
    <div class="center-container">
      <HomeSvg></HomeSvg>
    </div>
    <div class="recommend-container">
      <h1>网站优势</h1>
      <div class="recommend">
        <div class="recommend-item" v-for="item in recommendList">
          <h2>{{ item.title }}</h2>
          <SvgIcon :name="item.icon!" class="icon" />
          <p>{{ item.desc }}</p>
        </div>
      </div>
    </div>
    <div class="menu">
      <h1>GIF工具导航</h1>
      <div v-for="route in routes">
        <h2>{{ route.meta?.title }}</h2>
        <div class="menu-box">
          <LinkCard
            v-for="item in route.children"
            :path="route.path"
            :meta="item.meta"
          >
          </LinkCard>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
definePageMeta({
  layout: "default",
  title: "首页",
  svgIcon: "home",
  keywords: "GIF,免费gif制作,简易gif,动图制作免费软件,gif在线制作免费,动图制作,gif生成软件,gif动图,gif中文网,在线工具,图片,视频,转换,编辑,制作,生成,动图",
  description:
    "GIF在线工具，提供GIF图片、视频转换、编辑、制作、生成等功能，免费快捷制作GIF动图。",
  sort: 0,
});

const title = 'easygif-首页';
const description = 'GIF在线工具，提供GIF图片、视频转换、编辑、制作、生成等功能，免费快捷制作GIF动图。';
const keywords = 'GIF,免费gif制作,简易gif,动图制作免费软件,gif在线制作免费,动图制作,gif生成软件,gif动图,gif中文网,在线工具,图片,视频,转换,编辑,制作,生成,动图';
useSeoMeta({
  title: title,
  keywords: keywords,
  ogTitle: title,
  description: description,
  ogDescription: description,
});

const routes = nestRoutes().filter((item) => item.path != '/' && item.path != '/about');

const recommendList = [
  {
    title: "无需安装",
    icon: "no-download",
    desc: "无需安装任何软件，直接在浏览器中制作GIF",
  },
  {
    title: "安全可靠",
    icon: "no-upload",
    desc: "网站不收集您的GIF文件，保证您的文件安全性",
  },
  {
    title: "不限参数",
    icon: "unlimit",
    desc: "不限制GIF制作时的参数，您可以自由制作GIF",
  },
  {
    title: "不限尺寸",
    icon: "size",
    desc: "不限制GIF的尺寸，构建任意大小的GIF",
  },
  {
    title: "不限文件大小",
    icon: "picture-size",
    desc: "不限制操作的GIF的文件大小，保证任意GIF均可操作",
  },
  {
    title: "任意次数",
    icon: "use-count",
    desc: "不限制任何使用次数，包括转换和下载",
  },
];
</script>

<style scoped lang="scss">
.app-container {
  padding: 80px 40px 0px;
  .banner {
    text-align: center;

    .banner-desc {
      h1 {
        font-size: 44px;
        font-weight: 800;
        color: var(--text-color);
        font-family: Inter, sans-serif;
        margin: 0px;
      }
      p {
        font-size: 16px;
        margin-top: 20px;
        color: var(--text-color-light);
        letter-spacing: 10px;
      }
    }
  }
  .center-container {
    text-align: center;
  }
  .recommend-container {
    padding: 40px 0px;
    h1 {
      text-align: center;
      font-size: 30px;
    }

    .recommend {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      gap: 50px;
      padding: 30px 80px;
      .recommend-item {
        text-align: center;
        // background: linear-gradient(to top, #f1f1f1, #eee);
        padding: 20px;
        min-height: 104px;
        // background: #fff;
        box-shadow: 0 10px 30px 0 rgba(176, 191, 231, 0.55);
        border-radius: 16px;
        h2 {
          font-size: 20px;
        }
        .icon {
          font-size: 50px;
          color: var(--primary-color);
        }
      }
    }
  }

  .menu {
    padding: 10px 80px;
    margin-bottom: 80px;

    h1 {
      text-align: center;
      font-size: 30px;
    }
    h2 {
      color: var(--primary-color);
    }

    .menu-box {
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      justify-content: center;
      gap: 10px 30px;
    }
  }
}
</style>
